import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';

const Footer = () => {
    const [version, setVersion] = useState<string>('');

    useEffect(() => {
        // Fetch version from version.json
        fetch('/version.json?t=' + Date.now())
            .then(res => res.json())
            .then(data => setVersion(data.version))
            .catch(() => setVersion('Unknown'));
    }, []);

    return (
        <React.Fragment>
            <footer className="footer">
                <Container fluid>
                    <Row>
                        <Col sm={12}>
                            <div className="text-center">
                                <div>
                                    {new Date().getFullYear()} © Atos Sistema Contabil
                                </div>
                                {version && (
                                    <div className="text-muted" style={{ fontSize: '0.75rem', marginTop: '4px' }}>
                                        v{version}
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment>
    );
};

export default Footer;